module.exports = __webpack_public_path__ + "img/dispatch.ea8b4722.png";